import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="hero-bild-text-klein"]';

/**
 * Friendation component
 */
export const heroBildTextKlein = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const handleParallax = () => {
      const itemA: HTMLElement = component.querySelector(
        '.images-item:nth-child(1)'
      );
      const itemB: HTMLElement = component.querySelector(
        '.images-item:nth-child(2)'
      );

      if (!itemA || !itemB) return;

      // fire the animation when viewport match the media query
      // this function revert the animation when the media query condition is false (we dont need to revert it on resize event)
      const breakpoint = gsap.matchMedia();
      breakpoint.add('(min-width: 768px)', () => {
        gsap.to(itemA, {
          yPercent: '-10',
          duration: 2,
          scrollTrigger: {
            trigger: component,
            scrub: 1,
            start: '0',
            end: 'center'
          }
        });

        gsap.to(itemB, {
          yPercent: '-30',
          duration: 2,
          scrollTrigger: {
            trigger: component,
            scrub: 1,
            start: '0',
            end: 'center'
          }
        });
      });
    };

    handleParallax();
  });
};
